// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3sI5e","emails":"CreateEditClinics_emails__3pjuS","emailTagLabel":"CreateEditClinics_emailTagLabel__6N72L"};